import apiInstance from "./apiInstance";

const addSchool = (school) => {
  return apiInstance.post("enschool", school);
};

const editSchool = (params) => {
  return apiInstance.put(`enschool/`, params);
};

const getSchoolById = (schoolId) => {
  return apiInstance.get(`/enschool/${schoolId}`);
};

const deleteSchoolById = (params) => {
  const { schoolId } = params;
  return apiInstance.delete(`/enschool/${schoolId}`);
};

const searchSchools = (searchCriteria) => {
  return apiInstance.post("/enschool/school/search", searchCriteria);
};

const getSchoolDetail = (params) => {
  const { schoolId } = params;
  return apiInstance.get(`/enschool/detail/school/${schoolId}`);
};

const addBranchToSchool = (params) => {
  const { schoolId, branchIdList } = params;
  return apiInstance.post(`/enschool/branch/${schoolId}`, branchIdList);
};

const deleteBranchToSchool = (params) => {
  const { schoolId, idList } = params;
  return apiInstance.delete(`/enschool/branch/${schoolId}`, {
    data: idList
  });
};

const editSchoolLevel = (values) => {
  const { schoolId, params } = values;
  return apiInstance.put(`/enschool/level/${schoolId}`, params);
};

const addLevelToSchool = (values) => {
  const { schoolId, params } = values;
  return apiInstance.post(`/enschool/level/${schoolId}`, params);
};

const deleteLevelFromSchool = (params) => {
  const { schoolId, levelId } = params;
  return apiInstance.delete(`/enschool/level/${schoolId}/${levelId}`);
};

const searchSchoolLevel = (params) => {
  //TODO: silinecek
  return apiInstance.post("/enschool/school/level/search", params);
};

const getSchoolLevel = (params) => {
  const { schoolId } = params;
  return apiInstance.get(`enschool/level/${schoolId}`);
};

const addMultiStudentPhoto = ({ termId, schoolId, images }) => {
  return apiInstance.post(`/enstudent/multiStudentPhotoUpload/${termId}/${schoolId}`, images);
};

const setStudentNoRange = ({ schoolId, params }) => {
  return apiInstance.post(`/enschool/school/schoolNo/${schoolId}`, params);
};

const searchDomainSchool = (params) => {
  return apiInstance.post("/enschool/search/domainSchool", params);
};

const schoolSearchSummary = (params) => {
  return apiInstance.post("/enschool/school/search/summary", params);
};

const editSchoolNoRange = ({ schoolId, params }) => {
  return apiInstance.post(`enschool/schoolNo/${schoolId}`, params);
};

const searchSchoolTemplate = (params) => {
  return apiInstance.post(`/enschool/schoolTemplate/search`, params);
};

//refactor
const getSchoolsByCorporationId = (corporationId) => {
  return apiInstance.post(`/enschool/school/getByCorporationId/${corporationId}`);
};

const getSchoolsByCampusId = (campusId) => {
  return apiInstance.post(`/enschool/school/getByCampusId/${campusId}`);
};

const getUserSchools = () => {
  return apiInstance.post(`/enschool/school/getUserSchools`);
};

const getSchoolBranchList = (schoolId) => {
  return apiInstance.post(`/enschool/school/getBranches/${schoolId}`);
};

const addOldSchool = (params) => {
  return apiInstance.post(`/enschool/school/addSchoolTemplate`, params);
};

const addSchoolEtudeSchdule = (params) => {
  return apiInstance.post(`/enschooletudeschedule`, params);
};

const getSchoolEtudeSchdule = (schoolId) => {
  return apiInstance.get(`/enschooletudeschedule/${schoolId}`);
};

const addSchoolWeeklySchedule = (params) => {
  return apiInstance.post(`/enschoolweeklyschedule`, params);
};

const getSchoolWeeklySchedule = (schoolId) => {
  return apiInstance.get(`/enschoolweeklyschedule/${schoolId}`);
};

const deleteSchoolWeeklySchedule = (scheduleId) => {
  return apiInstance.delete(`/enschoolweeklyschedule/${scheduleId}`);
};

const getSchoolNoteShareConfig = (schoolId) => {
  return apiInstance.get(`enschool/noteshareconfig/get/${schoolId}`);
};

const addEditSchoolNoteShareConfig = (params) => {
  return apiInstance.post(`/enschool/noteshareconfig/addEdit`, params);
};

const editSchoolIBANno = ({ schoolId, iban }) => {
  return apiInstance.post(`/enschool/school/updateIBAN/${schoolId}`, { iban });
};

const getSchoolIBANno = ({ schoolId }) => {
  return apiInstance.get(`/enschool/school/getIBAN/${schoolId}`);
};

export {
  getSchoolIBANno,
  editSchoolIBANno,
  addSchool,
  editSchool,
  getSchoolById,
  deleteSchoolById,
  searchSchools,
  getSchoolDetail,
  addLevelToSchool,
  deleteLevelFromSchool,
  addBranchToSchool,
  deleteBranchToSchool,
  getSchoolLevel,
  addMultiStudentPhoto,
  setStudentNoRange,
  editSchoolLevel,
  searchDomainSchool,
  searchSchoolLevel,
  schoolSearchSummary,
  editSchoolNoRange,
  searchSchoolTemplate,
  getSchoolsByCorporationId,
  getSchoolsByCampusId,
  getUserSchools,
  getSchoolBranchList,
  addOldSchool,
  addSchoolEtudeSchdule,
  getSchoolEtudeSchdule,
  addSchoolWeeklySchedule,
  getSchoolWeeklySchedule,
  deleteSchoolWeeklySchedule,
  getSchoolNoteShareConfig,
  addEditSchoolNoteShareConfig
};
